import {
  ApiCartChangeCartTypeRequestedAction,
  apiCartChangeCartTypeFailed,
  apiCartChangeCartTypeSucceeded
} from '../../../api/cart/changeCartTypeApi';
import { call, put } from 'typed-redux-saga';
import changeCartTypeAction, {
  ChangeCartTypeActionInput,
  ChangeCartTypeActionResult
} from '@spa/lib/actions/cart/changeCartTypeAction';

function* changeCartTypeSaga({
  payload: { actionId: requestedActionId, customOrderType, parentActionId, sourceCustomOrderType }
}: ApiCartChangeCartTypeRequestedAction): Generator {
  try {
    const input: ChangeCartTypeActionInput = {
      sourceCustomOrderType,
      targetCustomOrderType: customOrderType
    };
    const { cartId, result }: ChangeCartTypeActionResult = yield* call(
      changeCartTypeAction,
      'changeCartTypeAction',
      input
    );
    yield* put(
      apiCartChangeCartTypeSucceeded({
        cartId,
        parentActionId,
        requestedActionId,
        result
      })
    );
  } catch {
    yield* put(apiCartChangeCartTypeFailed({ parentActionId, requestedActionId }));
  }
}

export default changeCartTypeSaga;
